import { formatDate, formatEndDate } from "presentation/utils/formatEndDate";
import { IEmployeeRepository } from "../../domain/contracts/employee.contract";
import { Employee } from "../../domain/entities/employee";
import { Message } from "../../domain/entities/message";
import { EmployeeInputFilter } from "../../domain/models/employee-input-filter";
import { httpClient } from "../axios/axios-api";

class EmployeeRepository implements IEmployeeRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/employee/${id}`);
    return response.data;
  }

  async create(input: Employee): Promise<Message<Employee>> {

    let rfiExpiresAt = formatDate(input.rfiExpiresAt);
    let terminationDate = formatDate(input.terminationDate);
    let birthDate = formatDate(input.birthDate);
    let admissionDate = formatDate(input.admissionDate);
    let newInput: any = { ...input, birthDate: birthDate, admissionDate: admissionDate, rfiExpiresAt: rfiExpiresAt, terminationDate: terminationDate };

    const response = await httpClient.post(`/employee`, { data: newInput });
    return response.data;
  }

  async update(input: Employee): Promise<Message<boolean>> {
   let rfiExpiresAt = formatDate(input.rfiExpiresAt);
    let terminationDate = formatDate(input.terminationDate);
    let birthDate = formatDate(input.birthDate);
    let admissionDate = formatDate(input.admissionDate);
    let newInput: any = { ...input, birthDate: birthDate, admissionDate: admissionDate, rfiExpiresAt: rfiExpiresAt, terminationDate: terminationDate };

    const response = await httpClient.put(`/employee/${input.id}`, {
      data: newInput,
    });
    return response.data;
  }

  async getAll(filter: EmployeeInputFilter): Promise<Message<Employee[]>> {
    const response = await httpClient.get(`/employee`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Employee>> {
    const response = await httpClient.get(`/employee/${id}`);
    return response.data;
  }
}

export default new EmployeeRepository();
